const ModalErrors= ({text}) => text!=''?<p className="alert alert-danger" style={{fontSize:"14px",padding:"5px 10px",background:"#dd0000",color:"white",textAlign:"center"}}>{text}</p>:<></>
export default ModalErrors
